module.exports = __webpack_public_path__ + "static/media/noimg-470x240.a1a21c58.jpg";